import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";

const BannerShcema = (isEdit = false) =>
  Yup.object().shape({
    sport_id: Yup.string().label("Sport").nullable(),
    language_id: Yup.string().label("Language").nullable(),
    language: Yup.string().required(),
    sport: Yup.string().required(),
    url_redirect: Yup.string().label("URL Redirect").nullable(),
    page: Yup.string().label("Page").required(),
    name: Yup.string().label("Name").required().max(255),
    status: Yup.string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
    image_url: Yup.mixed()
      .label("Image URL")
      .when([], {
        is: () => isEdit,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required(),
      }),
  });

export default BannerShcema;
